let longLoadingTimer;
let loadingGraceTimer;

const GRACE_DELAY = 500;

export default {
  namespaced: true,

  state: {
    loading: false,
    msgLongLoading: false,
    timeout: false,

    allowed: false,

    backdoor: 1, //to recompute computed value
    
    affiliateCode: '',
  },

  getters: {
    loading(state){
      return state.loading;
    },
    msgLongLoading(state){
      return state.msgLongLoading;
    },
    timeout(state){
      return state.timeout;
    },
    backdoor(state){
      return state.backdoor;
    },
    allowed(state){
      return state.allowed;
    },
    affiliateCode(state){
      return state.affiliateCode;
    }
  },

  //Bloqué sur le loader quand déconecté automatiquement
  mutations: {
    SET_LOADING(state, loading){
      clearTimeout(longLoadingTimer);
      clearTimeout(loadingGraceTimer)

      if (loading === true) {
        state.loading = true;
        state.msgLongLoading = false;

        longLoadingTimer = setTimeout(() => {
          state.msgLongLoading = true;
        }, 4500);

        return;
      }

      loadingGraceTimer = setTimeout(() => {
        state.loading = false;
      }, GRACE_DELAY);
    },
    SET_BACKDOOR(state, num){
      state.backdoor = num;
    },
    SET_ALLOWED(state, allowed){
      state.allowed = allowed;
    },
    SET_AFFILIATECODE(state, code){
      state.affiliateCode = code;
    }
  },
};
